﻿import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Address } from '@/types';

interface UserState {
  addresses: Address[];
  isLoading: boolean;
  error: string | null;
}

const initialState: UserState = {
  addresses: [],
  isLoading: false,
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAddresses: (state, action: PayloadAction<Address[]>) => {
      state.addresses = action.payload;
    },
    addAddress: (state, action: PayloadAction<Address>) => {
      if (action.payload.isDefault) {
        state.addresses.forEach((addr) => (addr.isDefault = false));
      }
      state.addresses.push(action.payload);
    },
    updateAddress: (state, action: PayloadAction<Address>) => {
      const index = state.addresses.findIndex((a) => a.id === action.payload.id || a.id === action.payload.uuid);
      if (index !== -1) {
        if (action.payload.isDefault) {
          state.addresses.forEach((addr) => (addr.isDefault = false));
        }
        state.addresses[index] = action.payload;
      }
    },
    removeAddress: (state, action: PayloadAction<string>) => {
      state.addresses = state.addresses.filter((a) => a.id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const userActions = userSlice.actions;

